import { Component, Input } from '@angular/core';
import { IImportHistory } from '../../../../models/import-history.model';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'jhi-bary-history-upload',
  templateUrl: './bary-history-upload.component.html',
  standalone: true,
  styleUrls: ['./bary-history-upload.component.scss'],
  imports: [TranslateModule, NgIf],
})
export class BaryHistoryUploadComponent {
  @Input() public importHistory: IImportHistory | null = null;
}
